import { useState } from "react";
import SignUp from "../../components/auth/signup";
import Header from "../../components/header";

// import { Wrapper } from "./signup-page.styled";

const SignUpPage = () => {
  return (
    <>
      <Header />
      <SignUp />
    </>
  );
};
export default SignUpPage;
